import { ListSubheader, Typography } from "@mui/material";
import { TypographyProps } from "@mui/material/Typography/Typography";
export interface DisplayListHeaderProps extends TypographyProps {
  title: string;
}

export const DisplayListHeader = ({ title, variant, children }: DisplayListHeaderProps) => {
  return (
    <ListSubheader sx={{
      paddingTop: 2,
      paddingBottom: 2,
      backgroundColor: "white",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
      color: "black",
    }}>
      <Typography variant={variant ?? "h3"} sx={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}>
        {title}
      </Typography>
      {children}
    </ListSubheader>
  );
};
